<template>
  <BaseAction>
    <UserDialog
      :is-open="userDialogOpen"
      v-if="userDialogOpen"
      @close="userDialogOpen = false"
      title="Invite New User"
      actionName="Invite User"
      @submit="addUser"
      :loading="isAddingUser"
    />
    <SecondaryButton @click.native="userDialogOpen = true" color="primary">
      <v-icon>
        mdi-account-plus-outline
      </v-icon>
      Invite User
    </SecondaryButton>
  </BaseAction>
</template>

<script>
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import UserDialog from "@/views/settings/Users/dialogs/UserDialog";
import { createNamespacedHelpers } from "vuex";
import { USERS_NAMESPACE } from "@/store/modules/users";
import { CREATE_USER } from "@/store/modules/users/actions";
import { GET_IS_ADDING_USER } from "@/store/modules/users/getters";
import BaseAction from "@/components/common/BaseAction";
import { SETTINGS_NAMESPACE } from "@/store/modules/settings";
import { FETCH_ORGANISATION_USERS } from "@/store/modules/settings/actions";
import { AUTH_NAMESPACE } from "@/store/modules/auth";
import { get } from "lodash";

const {
  mapActions: mapUserActions,
  mapGetters: mapUserGetters
} = createNamespacedHelpers(USERS_NAMESPACE);
const { mapActions: mapSettingsActions } = createNamespacedHelpers(
  SETTINGS_NAMESPACE
);
const { mapState: mapAuthState } = createNamespacedHelpers(AUTH_NAMESPACE);

export default {
  name: "NewUserAction",
  components: { UserDialog, SecondaryButton, BaseAction },
  data() {
    return {
      userDialogOpen: false
    };
  },
  computed: {
    ...mapAuthState({
      self: state => state.userData
    }),
    ...mapUserGetters({
      isAddingUser: GET_IS_ADDING_USER
    }),
    selfOrganisationId() {
      return get(this.self, "organisation.id");
    }
  },
  methods: {
    ...mapUserActions({
      createUser: CREATE_USER
    }),
    ...mapSettingsActions({
      fetchOrganisationUsers: FETCH_ORGANISATION_USERS
    }),
    async addUser(userData) {
      await this.createUser(userData);
      this.fetchOrganisationUsers({
        "page[size]": 10,
        "page[number]": 1,
        filter: {
          organisation_id: this.selfOrganisationId
        }
      });
      this.userDialogOpen = false;
    }
  }
};
</script>

<style scoped></style>
